import { render, staticRenderFns } from "./ProposalEvaluationHeader.vue?vue&type=template&id=596cd623&scoped=true"
import script from "./ProposalEvaluationHeader.vue?vue&type=script&lang=js"
export * from "./ProposalEvaluationHeader.vue?vue&type=script&lang=js"
import style0 from "./ProposalEvaluationHeader.vue?vue&type=style&index=0&id=596cd623&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cd623",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596cd623')) {
      api.createRecord('596cd623', component.options)
    } else {
      api.reload('596cd623', component.options)
    }
    module.hot.accept("./ProposalEvaluationHeader.vue?vue&type=template&id=596cd623&scoped=true", function () {
      api.rerender('596cd623', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/ProposalEvaluationHeader.vue"
export default component.exports